// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"dd8eb138f743d5285af4","326":"46a8055bbf36bca72bd7","583":"4381dc10e8399d06ad99"}[chunkId] + ".css";
};